import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';
import MobileMenu from './components/MobileMenu';
import ProjetsPage from './components/ProjetsPage';
import Presentation from './pages/Presentation';
import Prestations from './pages/Prestations';
import Contact from './pages/Contact';
import HeroAnimation from './components/HeroAnimation';
import heroBg from './assets/hero-bg.jpg';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/presentation" element={<Presentation />} />
        <Route path="/prestations" element={<Prestations />} />
        <Route path="/projets" element={<ProjetsWrapper />} />
        <Route path="/bim" element={<PageLayout title="BIM" />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </BrowserRouter>
  );
}

function HomePage() {
  const [mobileOpen, setMobileOpen] = useState(false);
  useEffect(() => {
    document.body.classList.toggle('mobile-menu-open', mobileOpen);
  }, [mobileOpen]);
  useEffect(() => {
    document.body.classList.add('home-page');
    return () => document.body.classList.remove('home-page');
  }, []);

    return (
    <div className="App fullscreen" style={{ background: 'url(' + heroBg + ') center / cover fixed no-repeat' }}>
      <Header onMenuToggle={() => setMobileOpen(!mobileOpen)} />
      {mobileOpen && <MobileMenu onClose={() => setMobileOpen(false)} />}
      <HeroAnimation />
    </div>
  );
}

function ProjetsWrapper() {
  const [mobileOpen, setMobileOpen] = useState(false);
  useEffect(() => {
    document.body.classList.toggle('mobile-menu-open', mobileOpen);
  }, [mobileOpen]);

  return (
    <div className="App" style={{ background: 'url(' + heroBg + ') left top / cover fixed no-repeat', minHeight: '100vh', display: 'flex', flexDirection: 'column', overflowY: 'auto' }}>
      <Header onMenuToggle={() => setMobileOpen(!mobileOpen)} />
      {mobileOpen && <MobileMenu onClose={() => setMobileOpen(false)} />}
      <ProjetsPage />
      <Footer />
      <BackToTop />
    </div>
  );
}

function PageLayout({ title }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  useEffect(() => {
    document.body.classList.toggle('mobile-menu-open', mobileOpen);
  }, [mobileOpen]);

  return (
    <div className="App" style={{ background: 'url(' + heroBg + ') left top / cover fixed no-repeat', minHeight: '100vh', display: 'flex', flexDirection: 'column', overflowY: 'auto' }}>
      <Header onMenuToggle={() => setMobileOpen(!mobileOpen)} />
      {mobileOpen && <MobileMenu onClose={() => setMobileOpen(false)} />}
      <div className="section page-content" style={{ padding: '100px 0', flex: 1 }}>
        <div style={{ background: 'rgba(255,255,255,0.88)', padding: '60px 0', borderRadius: 8, margin: '0 15px' }}>
          <div className="section-title">
            <h2>{title}</h2>
            <div className="title-bar"></div>
            <p className="section-subtitle">Page en cours de construction</p>
            <Link to="/" style={{ display: 'inline-block', marginTop: 20, color: 'var(--primary)', fontWeight: 500 }}>Retour à l'accueil</Link>
          </div>
        </div>
      </div>
      <Footer />
      <BackToTop />
    </div>
  );
}

export default App;

